// Lib
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Utils
import { decodeParams } from '../../common/utils/urlUtil';

// Actions
import { handleSuccessfulAuthentication } from './authActions';
import {
    isSafeRedirectUrl,
    navigateToLogin,
    navigateToRootWorkspace,
    safeRedirectTo,
} from '../reducers/navigationActions';
import { fetchCurrentUser } from '../user/currentUserActions';

// Constants
import { APP_QUERY_PARAMS } from '../../common/utils/urlConstants';

const getToken = get([APP_QUERY_PARAMS.AUTH_TOKEN]);

export default (onSuccessActionFn) => {
    const ReferralRedirect = ({ location }) => {
        const dispatch = useDispatch();

        useEffect(() => {
            const dispatchOnSuccess = (token, redirectParams) =>
                dispatch((_dispatch, getState) => {
                    const successRedirect = redirectParams[APP_QUERY_PARAMS.SUCCESS_REDIRECT];

                    onSuccessActionFn && dispatch(onSuccessActionFn(redirectParams));

                    // App-origin OAuth returns success_redirect in the URL hash on the
                    // register-success/login-success routes, so preserve it explicitly here.
                    const successCallback =
                        successRedirect && isSafeRedirectUrl(successRedirect)
                            ? () => safeRedirectTo(successRedirect)
                            : undefined;

                    // use replace so the token doesn't get into the browser history stack
                    handleSuccessfulAuthentication({ replaceUrl: true, successCallback, dispatch, getState })({
                        data: { token },
                    });
                });
            const dispatchOnSessionSuccess = (queryParams) =>
                dispatch(async (_dispatch, getState) => {
                    try {
                        await dispatch(fetchCurrentUser());
                    } catch (error) {
                        // Ignore fetch errors and fall back to login redirect below.
                    }

                    const isAuthenticated = getState().getIn(['app', 'currentUser', 'authenticated']);
                    if (isAuthenticated) {
                        onSuccessActionFn && dispatch(onSuccessActionFn(queryParams));
                        dispatch(navigateToRootWorkspace(true));
                        return;
                    }

                    dispatch(navigateToLogin({ from: encodeURIComponent('/') }));
                });

            const hashParams = decodeParams(location.hash);
            const queryParams = location.query;
            const redirectParams = {
                ...hashParams,
                ...queryParams,
            };

            const token = getToken(hashParams) || getToken(queryParams);

            if (token) {
                dispatchOnSuccess(token, redirectParams);
                return;
            }

            dispatchOnSessionSuccess(queryParams);
        }, [location]);

        return null;
    };

    ReferralRedirect.propTypes = {
        location: PropTypes.object,
    };

    return ReferralRedirect;
};
